import {
    PARRAINAGE_MESSAGES_RESET,
    RESET_PARRAINAGE_MESSAGES_SUCCESS,
    CREATE_PARRAINAGE_FAILED,
    CREATE_PARRAINAGE_REQUEST,
    CREATE_PARRAINAGE_SUCCESS,
    DELETE_PARRAINAGE_FAILED,
    DELETE_PARRAINAGE_REQUEST,
    DELETE_PARRAINAGE_SUCCESS,
    GET_PARRAINAGE_BY_NAME_FAILED,
    GET_PARRAINAGE_BY_NAME_REQUEST,
    GET_PARRAINAGE_BY_NAME_SUCCESS,
    GET_PARRAINAGE_FAILED,
    GET_PARRAINAGE_REQUEST,
    GET_PARRAINAGE_SUCCESS,
    UPDATE_PARRAINAGE_FAILED,
    UPDATE_PARRAINAGE_REQUEST,
    UPDATE_PARRAINAGE_SUCCESS,
  } from "./actionTypes"
  
  export const initialState = {
    loading: false,
    parrainageData: [],
    success: "",
    error: "",
  }
  
  function reducer(state = initialState, action) {
    switch (action.type) {
      case GET_PARRAINAGE_REQUEST:
        return {
          ...state,
          success: "",
          error: "",
          loading: true,
        }
      case GET_PARRAINAGE_SUCCESS:
        const {data, ...filters} = action.payload
        return {
          ...state,
          parrainageData: [...data],
          ...filters,
          loading: false,
          success: "GET",
        }
      case GET_PARRAINAGE_FAILED:
        return {
          ...state,
          error: action.payload.message,
          loading: false,
        }
      case GET_PARRAINAGE_BY_NAME_REQUEST:
        return {
          ...state,
          success: "",
          error: "",
          loading: true,
        }
      case GET_PARRAINAGE_BY_NAME_SUCCESS:
        return {
          ...state,
          parrainageData: action.payload,
          loading: false,
          success: "SUCCESS",
        }
      case GET_PARRAINAGE_BY_NAME_FAILED:
        return {
          ...state,
          error: action.payload.message,
          loading: false,
        }
      case CREATE_PARRAINAGE_REQUEST:
        return {
          ...state,
          loading: true,
        }
      case CREATE_PARRAINAGE_SUCCESS:
        return {
          ...state,
          parrainageData: [...state.parrainageData, action.payload],
          success: "CREATE",
          loading: false,
        }
      case CREATE_PARRAINAGE_FAILED:
        return {
          ...state,
          error: "FAILED CREATE",
          loading: false,
        }
      case DELETE_PARRAINAGE_REQUEST:
        return {
          ...state,
          loading: true,
          success: "",
          error: "",
        }
      case DELETE_PARRAINAGE_SUCCESS:
        return {
          ...state,
          parrainageData: state.parrainageData.filter(
            parrainage => parrainage.id.toString() !== action.payload.toString()
          ),
          success: "DELETE",
          loading: false,
        }
      case DELETE_PARRAINAGE_FAILED:
        return {
          ...state,
          error: "FAILED DELETE",
          loading: false,
        }
      case UPDATE_PARRAINAGE_REQUEST:
        return {
          ...state,
          loading: true,
          success: "",
          error: "",
        }
      case UPDATE_PARRAINAGE_SUCCESS:
        return {
          ...state,
          countriesData: state.countriesData.map(parrainage =>
            parrainage.id.toString() === action.payload.id.toString()
              ? { parrainage, ...action.payload }
              : parrainage
          ),
          success: "UPDATE",
          loading: false,
        }
      case UPDATE_PARRAINAGE_FAILED:
        return {
          ...state,
          error: "FAILED UPDATE",
          loading: false,
        }
      case PARRAINAGE_MESSAGES_RESET:
        return {
          ...state,
          error: "",
          success: "",
          loading: false,
        }
        case RESET_PARRAINAGE_MESSAGES_SUCCESS:
          return {
            ...state,
            error: null,
            success: null
          }
      default:
        return state
    }
  }
  
  export default reducer
  
